"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _types = _interopRequireDefault(require("./types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * settings: {
 *     renderAs: "unorderedList",
 *     valuePath: some.path[0].to.stuff
 * }
 */
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var RenderClass = _types["default"][settings.renderAs];
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('table-renderers-array')
    }, /*#__PURE__*/_react["default"].createElement(RenderClass, {
      settings: settings,
      items: value,
      row: row
    }));
  };
};